import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { TransactionSerie } from "../../transactions-series/_types/transaction-serie";
import { Address } from "../../common/_types/address";

export class Company extends Resource {
    public override type = 'companies';

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public legalName!: string;

    @prop()
    @required()
    public typeOfBusiness: number = 1;

    @prop()
    public email!: string;

    @prop()
    public phone1!: string;

    @prop()
    public phone1Description!: string;

    @prop()
    public phone2!: string;
    @prop()
    public phone2Description!: string;

    @prop()
    public phone3!: string;
    @prop()
    public phone3Description!: string;

    @prop()
    public priorityPhone!: number;

    @prop()
    public active: boolean = true;

    @prop()
    public vatNumber!: string;

    @prop()
    public addressId!: string;

    @propObject(Address)
    public address: Address = new Address();

    @prop()
    public transactionSerieId!: string;

    @prop()
    public transactionSerie!: TransactionSerie;

}